import { render, staticRenderFns } from "./InterpretsDetail.vue?vue&type=template&id=14c2122c&lang=html&"
import script from "./InterpretsDetail.vue?vue&type=script&lang=js&"
export * from "./InterpretsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports